import { useEffect } from "react";

import useUserStore from "@store/useUserStore";
import useDialogStore from "@store/useDialogStore";
import useMaintenanceStore from "@store/useMaintenanceStore";
import { getMaintenanceWindowKey, isMaintenanceAlertDay } from "@utils/maintenance.util";

import { useMaintenanceStatus } from "./useMaintenanceStatus";
import { MaintenanceAlertModal } from "../MaintenanceAlertModal";

/**
 * Shows the pre-maintenance alert modal on the user's first login the day before a
 * scheduled maintenance window, at most once per window per device. Reads the window
 * published by the tools service — the same status the gate polls.
 */
export function useMaintenanceAlert() {
  const { hasSession } = useUserStore();
  const { openDialog } = useDialogStore();

  const window = useMaintenanceStatus().status?.window ?? null;

  useEffect(() => {
    if (!hasSession || !window) return;

    const windowKey = getMaintenanceWindowKey(window);
    const { lastAlertedWindowKey, markAlertShown } = useMaintenanceStore.getState();

    if (lastAlertedWindowKey === windowKey) return;
    if (!isMaintenanceAlertDay(window, window.organizationTimeZone)) return;

    markAlertShown(windowKey);
    openDialog(<MaintenanceAlertModal window={window} />);
  }, [hasSession, window, openDialog]);
}
